import React from 'react';
import NavigationLinks from '../../UI/NavigationLinks/NavigationLinks';
import Logo from '../../UI/Logo/Logo';
import classes from './Sidedrawer.css';
const sideDrawer = (props) => {
let sideDrawer = null;
if(props.show) {

    sideDrawer =  (<section className={classes.appDrawer}>
    {/* <Logo isFixedSize isTop30Margin isBottom30Margin /> */}
    <NavigationLinks />
    </section>);
    
}
return sideDrawer;
};


export default sideDrawer;


// WEBPACK FOOTER //
// ./src/components/Navigation/Sidedrawer/Sidedrawer.js